import React from "react"
import About from "../components/About/About";
import CursorManager from "../components/CustomCursor/context/ContextManager";
import CustomCursor from "../components/CustomCursor/CustomCursor";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import SEO from "../components/seo";
import Socials from "../components/Socials/Socials";
import { ThemeProvider } from "../components/ThemeButton/ThemeProvider";

const AboutPage = () => (
    <div>
        <SEO title="About" />
        <ThemeProvider>
        <CursorManager>
            <>
                <CustomCursor/>
                <Header />
                <Socials />
                <About />
                <Footer />
            </>
        </CursorManager>
      </ThemeProvider>
    </div>
)

export default AboutPage;
